import {Component, ElementRef, Input, Renderer2} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'cp-ground',
    templateUrl: 'cp-ground.html',
    providers: []
})
export class CpGround {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;

    constructor(public element: ElementRef, private renderer: Renderer2) {

    }

    ngOnInit() {

        this.renderer.addClass(this.element.nativeElement, 'display-block');
        this.renderer.addClass(this.element.nativeElement, 'position-relative');
        this.renderer.addClass(this.element.nativeElement, 'overflow-hidden');

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/cp-ground/cp-ground.ts